export const Type = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
    <path
      d="M7.50105 4.3741L8.82254 3.05261C9.47341 2.40174 10.5287 2.40173 11.1796 3.05261L12.5011 4.3741M4.37605 7.4991L3.05456 8.82059C2.40369 9.47146 2.40369 10.5267 3.05456 11.1776L4.37605 12.4991M15.6261 7.4991L16.9475 8.82059C17.5984 9.47146 17.5984 10.5267 16.9475 11.1776L15.6261 12.4991M12.5011 15.6241L11.1796 16.9456C10.5287 17.5965 9.47341 17.5965 8.82254 16.9456L7.50105 15.6241"
      stroke="#7A7A83"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)

export default Type
